/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WRouteImport } from './routes/w'
import { Route as TRouteImport } from './routes/t'
import { Route as RequestedDetailsRouteImport } from './routes/requested-details'
import { Route as PRouteImport } from './routes/p'
import { Route as ERouteImport } from './routes/e'
import { Route as ComponentShowcaseRouteImport } from './routes/component-showcase'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TIndexRouteImport } from './routes/t/index'
import { Route as PIndexRouteImport } from './routes/p/index'
import { Route as EIndexRouteImport } from './routes/e/index'
import { Route as WUsersRouteImport } from './routes/w/users'
import { Route as WTenantTemplatesRouteImport } from './routes/w/tenant-templates'
import { Route as WSigningRequestsRouteImport } from './routes/w/signing-requests'
import { Route as WRolesRouteImport } from './routes/w/roles'
import { Route as WProductTypesRouteImport } from './routes/w/product-types'
import { Route as WModulesRouteImport } from './routes/w/modules'
import { Route as WFormRouteImport } from './routes/w/form'
import { Route as WEntityTemplatesRouteImport } from './routes/w/entity-templates'
import { Route as WEntitiesRouteImport } from './routes/w/entities'
import { Route as WEmploymentTypesRouteImport } from './routes/w/employment-types'
import { Route as WEmployeesRouteImport } from './routes/w/employees'
import { Route as WEmployeeTemplatesRouteImport } from './routes/w/employee-templates'
import { Route as WDocumentsRouteImport } from './routes/w/documents'
import { Route as WDocumentTypesRouteImport } from './routes/w/document-types'
import { Route as WDocumentTemplatesRouteImport } from './routes/w/document-templates'
import { Route as WDashboardRouteImport } from './routes/w/dashboard'
import { Route as WContractsRouteImport } from './routes/w/contracts'
import { Route as TUsersRouteImport } from './routes/t/users'
import { Route as TSigningRequestsRouteImport } from './routes/t/signing-requests'
import { Route as TRolesRouteImport } from './routes/t/roles'
import { Route as TJobTitlesRouteImport } from './routes/t/job-titles'
import { Route as TEmployeesRouteImport } from './routes/t/employees'
import { Route as TDocumentsRouteImport } from './routes/t/documents'
import { Route as TDepartmentsRouteImport } from './routes/t/departments'
import { Route as TContractsRouteImport } from './routes/t/contracts'
import { Route as EEmployeeOnboardingRouteImport } from './routes/e/employee-onboarding'
import { Route as EEmployeeCompleteRouteImport } from './routes/e/employee-complete'
import { Route as WUsersIndexRouteImport } from './routes/w/users/index'
import { Route as WTenantTemplatesIndexRouteImport } from './routes/w/tenant-templates/index'
import { Route as WSigningRequestsIndexRouteImport } from './routes/w/signing-requests/index'
import { Route as WRolesIndexRouteImport } from './routes/w/roles/index'
import { Route as WProductTypesIndexRouteImport } from './routes/w/product-types/index'
import { Route as WModulesIndexRouteImport } from './routes/w/modules/index'
import { Route as WFormIndexRouteImport } from './routes/w/form/index'
import { Route as WEntityTemplatesIndexRouteImport } from './routes/w/entity-templates/index'
import { Route as WEntitiesIndexRouteImport } from './routes/w/entities/index'
import { Route as WEmploymentTypesIndexRouteImport } from './routes/w/employment-types/index'
import { Route as WEmployeesIndexRouteImport } from './routes/w/employees/index'
import { Route as WEmployeeTemplatesIndexRouteImport } from './routes/w/employee-templates/index'
import { Route as WDocumentsIndexRouteImport } from './routes/w/documents/index'
import { Route as WDocumentTypesIndexRouteImport } from './routes/w/document-types/index'
import { Route as WDocumentTemplatesIndexRouteImport } from './routes/w/document-templates/index'
import { Route as WDashboardIndexRouteImport } from './routes/w/dashboard/index'
import { Route as WContractsIndexRouteImport } from './routes/w/contracts/index'
import { Route as TUsersIndexRouteImport } from './routes/t/users/index'
import { Route as TSigningRequestsIndexRouteImport } from './routes/t/signing-requests/index'
import { Route as TRolesIndexRouteImport } from './routes/t/roles/index'
import { Route as TJobTitlesIndexRouteImport } from './routes/t/job-titles/index'
import { Route as TEmployeesIndexRouteImport } from './routes/t/employees/index'
import { Route as TDocumentsIndexRouteImport } from './routes/t/documents/index'
import { Route as TDocumentTemplatesIndexRouteImport } from './routes/t/document-templates/index'
import { Route as TDepartmentsIndexRouteImport } from './routes/t/departments/index'
import { Route as TContractsIndexRouteImport } from './routes/t/contracts/index'
import { Route as WSigningRequestsNewRouteImport } from './routes/w/signing-requests/new'
import { Route as WSigningRequestsRequestIdRouteImport } from './routes/w/signing-requests/$requestId'
import { Route as WRolesAddRouteImport } from './routes/w/roles/add'
import { Route as WFormPreviewRouteImport } from './routes/w/form/preview'
import { Route as WFormAddRouteImport } from './routes/w/form/add'
import { Route as WEntityTemplatesAddRouteImport } from './routes/w/entity-templates/add'
import { Route as WEmployeeTemplatesAddRouteImport } from './routes/w/employee-templates/add'
import { Route as WDocumentTemplatesTemplateIdRouteImport } from './routes/w/document-templates/$templateId'
import { Route as WContractsSnapshotIdRouteImport } from './routes/w/contracts/$snapshotId'
import { Route as TSigningRequestsRequestIdRouteImport } from './routes/t/signing-requests/$requestId'
import { Route as TRolesAddRouteImport } from './routes/t/roles/add'
import { Route as TProfileIdRouteImport } from './routes/t/profile.$id'
import { Route as TContractsSnapshotIdRouteImport } from './routes/t/contracts/$snapshotId'
import { Route as WSigningRequestsRequestIdEditRouteImport } from './routes/w/signing-requests/$requestId_.edit'
import { Route as WEntityTemplatesViewTemplateIdRouteImport } from './routes/w/entity-templates/view.$templateId'
import { Route as WEntitiesProfileEntityIdRouteImport } from './routes/w/entities/profile.$entityId'
import { Route as WEmployeesProfileEmployeeIdRouteImport } from './routes/w/employees/profile.$employeeId'
import { Route as WEmployeeTemplatesViewTemplateIdRouteImport } from './routes/w/employee-templates/view.$templateId'
import { Route as WDashboardProfileTenantIdRouteImport } from './routes/w/dashboard/profile.$tenantId'
import { Route as TEmployeesProfileEmployeeIdRouteImport } from './routes/t/employees/profile.$employeeId'

const WRoute = WRouteImport.update({
  id: '/w',
  path: '/w',
  getParentRoute: () => rootRouteImport,
} as any)
const TRoute = TRouteImport.update({
  id: '/t',
  path: '/t',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestedDetailsRoute = RequestedDetailsRouteImport.update({
  id: '/requested-details',
  path: '/requested-details',
  getParentRoute: () => rootRouteImport,
} as any)
const PRoute = PRouteImport.update({
  id: '/p',
  path: '/p',
  getParentRoute: () => rootRouteImport,
} as any)
const ERoute = ERouteImport.update({
  id: '/e',
  path: '/e',
  getParentRoute: () => rootRouteImport,
} as any)
const ComponentShowcaseRoute = ComponentShowcaseRouteImport.update({
  id: '/component-showcase',
  path: '/component-showcase',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TIndexRoute = TIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TRoute,
} as any)
const PIndexRoute = PIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PRoute,
} as any)
const EIndexRoute = EIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ERoute,
} as any)
const WUsersRoute = WUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => WRoute,
} as any)
const WTenantTemplatesRoute = WTenantTemplatesRouteImport.update({
  id: '/tenant-templates',
  path: '/tenant-templates',
  getParentRoute: () => WRoute,
} as any)
const WSigningRequestsRoute = WSigningRequestsRouteImport.update({
  id: '/signing-requests',
  path: '/signing-requests',
  getParentRoute: () => WRoute,
} as any)
const WRolesRoute = WRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => WRoute,
} as any)
const WProductTypesRoute = WProductTypesRouteImport.update({
  id: '/product-types',
  path: '/product-types',
  getParentRoute: () => WRoute,
} as any)
const WModulesRoute = WModulesRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => WRoute,
} as any)
const WFormRoute = WFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => WRoute,
} as any)
const WEntityTemplatesRoute = WEntityTemplatesRouteImport.update({
  id: '/entity-templates',
  path: '/entity-templates',
  getParentRoute: () => WRoute,
} as any)
const WEntitiesRoute = WEntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => WRoute,
} as any)
const WEmploymentTypesRoute = WEmploymentTypesRouteImport.update({
  id: '/employment-types',
  path: '/employment-types',
  getParentRoute: () => WRoute,
} as any)
const WEmployeesRoute = WEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => WRoute,
} as any)
const WEmployeeTemplatesRoute = WEmployeeTemplatesRouteImport.update({
  id: '/employee-templates',
  path: '/employee-templates',
  getParentRoute: () => WRoute,
} as any)
const WDocumentsRoute = WDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => WRoute,
} as any)
const WDocumentTypesRoute = WDocumentTypesRouteImport.update({
  id: '/document-types',
  path: '/document-types',
  getParentRoute: () => WRoute,
} as any)
const WDocumentTemplatesRoute = WDocumentTemplatesRouteImport.update({
  id: '/document-templates',
  path: '/document-templates',
  getParentRoute: () => WRoute,
} as any)
const WDashboardRoute = WDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => WRoute,
} as any)
const WContractsRoute = WContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => WRoute,
} as any)
const TUsersRoute = TUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => TRoute,
} as any)
const TSigningRequestsRoute = TSigningRequestsRouteImport.update({
  id: '/signing-requests',
  path: '/signing-requests',
  getParentRoute: () => TRoute,
} as any)
const TRolesRoute = TRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => TRoute,
} as any)
const TJobTitlesRoute = TJobTitlesRouteImport.update({
  id: '/job-titles',
  path: '/job-titles',
  getParentRoute: () => TRoute,
} as any)
const TEmployeesRoute = TEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => TRoute,
} as any)
const TDocumentsRoute = TDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => TRoute,
} as any)
const TDepartmentsRoute = TDepartmentsRouteImport.update({
  id: '/departments',
  path: '/departments',
  getParentRoute: () => TRoute,
} as any)
const TContractsRoute = TContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => TRoute,
} as any)
const EEmployeeOnboardingRoute = EEmployeeOnboardingRouteImport.update({
  id: '/employee-onboarding',
  path: '/employee-onboarding',
  getParentRoute: () => ERoute,
} as any)
const EEmployeeCompleteRoute = EEmployeeCompleteRouteImport.update({
  id: '/employee-complete',
  path: '/employee-complete',
  getParentRoute: () => ERoute,
} as any)
const WUsersIndexRoute = WUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WUsersRoute,
} as any)
const WTenantTemplatesIndexRoute = WTenantTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WTenantTemplatesRoute,
} as any)
const WSigningRequestsIndexRoute = WSigningRequestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WSigningRequestsRoute,
} as any)
const WRolesIndexRoute = WRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WRolesRoute,
} as any)
const WProductTypesIndexRoute = WProductTypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WProductTypesRoute,
} as any)
const WModulesIndexRoute = WModulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WModulesRoute,
} as any)
const WFormIndexRoute = WFormIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WFormRoute,
} as any)
const WEntityTemplatesIndexRoute = WEntityTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WEntityTemplatesRoute,
} as any)
const WEntitiesIndexRoute = WEntitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WEntitiesRoute,
} as any)
const WEmploymentTypesIndexRoute = WEmploymentTypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WEmploymentTypesRoute,
} as any)
const WEmployeesIndexRoute = WEmployeesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WEmployeesRoute,
} as any)
const WEmployeeTemplatesIndexRoute = WEmployeeTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WEmployeeTemplatesRoute,
} as any)
const WDocumentsIndexRoute = WDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WDocumentsRoute,
} as any)
const WDocumentTypesIndexRoute = WDocumentTypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WDocumentTypesRoute,
} as any)
const WDocumentTemplatesIndexRoute = WDocumentTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WDocumentTemplatesRoute,
} as any)
const WDashboardIndexRoute = WDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WDashboardRoute,
} as any)
const WContractsIndexRoute = WContractsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WContractsRoute,
} as any)
const TUsersIndexRoute = TUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TUsersRoute,
} as any)
const TSigningRequestsIndexRoute = TSigningRequestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TSigningRequestsRoute,
} as any)
const TRolesIndexRoute = TRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TRolesRoute,
} as any)
const TJobTitlesIndexRoute = TJobTitlesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TJobTitlesRoute,
} as any)
const TEmployeesIndexRoute = TEmployeesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TEmployeesRoute,
} as any)
const TDocumentsIndexRoute = TDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TDocumentsRoute,
} as any)
const TDocumentTemplatesIndexRoute = TDocumentTemplatesIndexRouteImport.update({
  id: '/document-templates/',
  path: '/document-templates/',
  getParentRoute: () => TRoute,
} as any)
const TDepartmentsIndexRoute = TDepartmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TDepartmentsRoute,
} as any)
const TContractsIndexRoute = TContractsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TContractsRoute,
} as any)
const WSigningRequestsNewRoute = WSigningRequestsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WSigningRequestsRoute,
} as any)
const WSigningRequestsRequestIdRoute =
  WSigningRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => WSigningRequestsRoute,
  } as any)
const WRolesAddRoute = WRolesAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => WRolesRoute,
} as any)
const WFormPreviewRoute = WFormPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => WFormRoute,
} as any)
const WFormAddRoute = WFormAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => WFormRoute,
} as any)
const WEntityTemplatesAddRoute = WEntityTemplatesAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => WEntityTemplatesRoute,
} as any)
const WEmployeeTemplatesAddRoute = WEmployeeTemplatesAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => WEmployeeTemplatesRoute,
} as any)
const WDocumentTemplatesTemplateIdRoute =
  WDocumentTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => WDocumentTemplatesRoute,
  } as any)
const WContractsSnapshotIdRoute = WContractsSnapshotIdRouteImport.update({
  id: '/$snapshotId',
  path: '/$snapshotId',
  getParentRoute: () => WContractsRoute,
} as any)
const TSigningRequestsRequestIdRoute =
  TSigningRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => TSigningRequestsRoute,
  } as any)
const TRolesAddRoute = TRolesAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => TRolesRoute,
} as any)
const TProfileIdRoute = TProfileIdRouteImport.update({
  id: '/profile/$id',
  path: '/profile/$id',
  getParentRoute: () => TRoute,
} as any)
const TContractsSnapshotIdRoute = TContractsSnapshotIdRouteImport.update({
  id: '/$snapshotId',
  path: '/$snapshotId',
  getParentRoute: () => TContractsRoute,
} as any)
const WSigningRequestsRequestIdEditRoute =
  WSigningRequestsRequestIdEditRouteImport.update({
    id: '/$requestId_/edit',
    path: '/$requestId/edit',
    getParentRoute: () => WSigningRequestsRoute,
  } as any)
const WEntityTemplatesViewTemplateIdRoute =
  WEntityTemplatesViewTemplateIdRouteImport.update({
    id: '/view/$templateId',
    path: '/view/$templateId',
    getParentRoute: () => WEntityTemplatesRoute,
  } as any)
const WEntitiesProfileEntityIdRoute =
  WEntitiesProfileEntityIdRouteImport.update({
    id: '/profile/$entityId',
    path: '/profile/$entityId',
    getParentRoute: () => WEntitiesRoute,
  } as any)
const WEmployeesProfileEmployeeIdRoute =
  WEmployeesProfileEmployeeIdRouteImport.update({
    id: '/profile/$employeeId',
    path: '/profile/$employeeId',
    getParentRoute: () => WEmployeesRoute,
  } as any)
const WEmployeeTemplatesViewTemplateIdRoute =
  WEmployeeTemplatesViewTemplateIdRouteImport.update({
    id: '/view/$templateId',
    path: '/view/$templateId',
    getParentRoute: () => WEmployeeTemplatesRoute,
  } as any)
const WDashboardProfileTenantIdRoute =
  WDashboardProfileTenantIdRouteImport.update({
    id: '/profile/$tenantId',
    path: '/profile/$tenantId',
    getParentRoute: () => WDashboardRoute,
  } as any)
const TEmployeesProfileEmployeeIdRoute =
  TEmployeesProfileEmployeeIdRouteImport.update({
    id: '/profile/$employeeId',
    path: '/profile/$employeeId',
    getParentRoute: () => TEmployeesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/component-showcase': typeof ComponentShowcaseRoute
  '/e': typeof ERouteWithChildren
  '/p': typeof PRouteWithChildren
  '/requested-details': typeof RequestedDetailsRoute
  '/t': typeof TRouteWithChildren
  '/w': typeof WRouteWithChildren
  '/e/employee-complete': typeof EEmployeeCompleteRoute
  '/e/employee-onboarding': typeof EEmployeeOnboardingRoute
  '/t/contracts': typeof TContractsRouteWithChildren
  '/t/departments': typeof TDepartmentsRouteWithChildren
  '/t/documents': typeof TDocumentsRouteWithChildren
  '/t/employees': typeof TEmployeesRouteWithChildren
  '/t/job-titles': typeof TJobTitlesRouteWithChildren
  '/t/roles': typeof TRolesRouteWithChildren
  '/t/signing-requests': typeof TSigningRequestsRouteWithChildren
  '/t/users': typeof TUsersRouteWithChildren
  '/w/contracts': typeof WContractsRouteWithChildren
  '/w/dashboard': typeof WDashboardRouteWithChildren
  '/w/document-templates': typeof WDocumentTemplatesRouteWithChildren
  '/w/document-types': typeof WDocumentTypesRouteWithChildren
  '/w/documents': typeof WDocumentsRouteWithChildren
  '/w/employee-templates': typeof WEmployeeTemplatesRouteWithChildren
  '/w/employees': typeof WEmployeesRouteWithChildren
  '/w/employment-types': typeof WEmploymentTypesRouteWithChildren
  '/w/entities': typeof WEntitiesRouteWithChildren
  '/w/entity-templates': typeof WEntityTemplatesRouteWithChildren
  '/w/form': typeof WFormRouteWithChildren
  '/w/modules': typeof WModulesRouteWithChildren
  '/w/product-types': typeof WProductTypesRouteWithChildren
  '/w/roles': typeof WRolesRouteWithChildren
  '/w/signing-requests': typeof WSigningRequestsRouteWithChildren
  '/w/tenant-templates': typeof WTenantTemplatesRouteWithChildren
  '/w/users': typeof WUsersRouteWithChildren
  '/e/': typeof EIndexRoute
  '/p/': typeof PIndexRoute
  '/t/': typeof TIndexRoute
  '/t/contracts/$snapshotId': typeof TContractsSnapshotIdRoute
  '/t/profile/$id': typeof TProfileIdRoute
  '/t/roles/add': typeof TRolesAddRoute
  '/t/signing-requests/$requestId': typeof TSigningRequestsRequestIdRoute
  '/w/contracts/$snapshotId': typeof WContractsSnapshotIdRoute
  '/w/document-templates/$templateId': typeof WDocumentTemplatesTemplateIdRoute
  '/w/employee-templates/add': typeof WEmployeeTemplatesAddRoute
  '/w/entity-templates/add': typeof WEntityTemplatesAddRoute
  '/w/form/add': typeof WFormAddRoute
  '/w/form/preview': typeof WFormPreviewRoute
  '/w/roles/add': typeof WRolesAddRoute
  '/w/signing-requests/$requestId': typeof WSigningRequestsRequestIdRoute
  '/w/signing-requests/new': typeof WSigningRequestsNewRoute
  '/t/contracts/': typeof TContractsIndexRoute
  '/t/departments/': typeof TDepartmentsIndexRoute
  '/t/document-templates/': typeof TDocumentTemplatesIndexRoute
  '/t/documents/': typeof TDocumentsIndexRoute
  '/t/employees/': typeof TEmployeesIndexRoute
  '/t/job-titles/': typeof TJobTitlesIndexRoute
  '/t/roles/': typeof TRolesIndexRoute
  '/t/signing-requests/': typeof TSigningRequestsIndexRoute
  '/t/users/': typeof TUsersIndexRoute
  '/w/contracts/': typeof WContractsIndexRoute
  '/w/dashboard/': typeof WDashboardIndexRoute
  '/w/document-templates/': typeof WDocumentTemplatesIndexRoute
  '/w/document-types/': typeof WDocumentTypesIndexRoute
  '/w/documents/': typeof WDocumentsIndexRoute
  '/w/employee-templates/': typeof WEmployeeTemplatesIndexRoute
  '/w/employees/': typeof WEmployeesIndexRoute
  '/w/employment-types/': typeof WEmploymentTypesIndexRoute
  '/w/entities/': typeof WEntitiesIndexRoute
  '/w/entity-templates/': typeof WEntityTemplatesIndexRoute
  '/w/form/': typeof WFormIndexRoute
  '/w/modules/': typeof WModulesIndexRoute
  '/w/product-types/': typeof WProductTypesIndexRoute
  '/w/roles/': typeof WRolesIndexRoute
  '/w/signing-requests/': typeof WSigningRequestsIndexRoute
  '/w/tenant-templates/': typeof WTenantTemplatesIndexRoute
  '/w/users/': typeof WUsersIndexRoute
  '/t/employees/profile/$employeeId': typeof TEmployeesProfileEmployeeIdRoute
  '/w/dashboard/profile/$tenantId': typeof WDashboardProfileTenantIdRoute
  '/w/employee-templates/view/$templateId': typeof WEmployeeTemplatesViewTemplateIdRoute
  '/w/employees/profile/$employeeId': typeof WEmployeesProfileEmployeeIdRoute
  '/w/entities/profile/$entityId': typeof WEntitiesProfileEntityIdRoute
  '/w/entity-templates/view/$templateId': typeof WEntityTemplatesViewTemplateIdRoute
  '/w/signing-requests/$requestId/edit': typeof WSigningRequestsRequestIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/component-showcase': typeof ComponentShowcaseRoute
  '/requested-details': typeof RequestedDetailsRoute
  '/w': typeof WRouteWithChildren
  '/e/employee-complete': typeof EEmployeeCompleteRoute
  '/e/employee-onboarding': typeof EEmployeeOnboardingRoute
  '/e': typeof EIndexRoute
  '/p': typeof PIndexRoute
  '/t': typeof TIndexRoute
  '/t/contracts/$snapshotId': typeof TContractsSnapshotIdRoute
  '/t/profile/$id': typeof TProfileIdRoute
  '/t/roles/add': typeof TRolesAddRoute
  '/t/signing-requests/$requestId': typeof TSigningRequestsRequestIdRoute
  '/w/contracts/$snapshotId': typeof WContractsSnapshotIdRoute
  '/w/document-templates/$templateId': typeof WDocumentTemplatesTemplateIdRoute
  '/w/employee-templates/add': typeof WEmployeeTemplatesAddRoute
  '/w/entity-templates/add': typeof WEntityTemplatesAddRoute
  '/w/form/add': typeof WFormAddRoute
  '/w/form/preview': typeof WFormPreviewRoute
  '/w/roles/add': typeof WRolesAddRoute
  '/w/signing-requests/$requestId': typeof WSigningRequestsRequestIdRoute
  '/w/signing-requests/new': typeof WSigningRequestsNewRoute
  '/t/contracts': typeof TContractsIndexRoute
  '/t/departments': typeof TDepartmentsIndexRoute
  '/t/document-templates': typeof TDocumentTemplatesIndexRoute
  '/t/documents': typeof TDocumentsIndexRoute
  '/t/employees': typeof TEmployeesIndexRoute
  '/t/job-titles': typeof TJobTitlesIndexRoute
  '/t/roles': typeof TRolesIndexRoute
  '/t/signing-requests': typeof TSigningRequestsIndexRoute
  '/t/users': typeof TUsersIndexRoute
  '/w/contracts': typeof WContractsIndexRoute
  '/w/dashboard': typeof WDashboardIndexRoute
  '/w/document-templates': typeof WDocumentTemplatesIndexRoute
  '/w/document-types': typeof WDocumentTypesIndexRoute
  '/w/documents': typeof WDocumentsIndexRoute
  '/w/employee-templates': typeof WEmployeeTemplatesIndexRoute
  '/w/employees': typeof WEmployeesIndexRoute
  '/w/employment-types': typeof WEmploymentTypesIndexRoute
  '/w/entities': typeof WEntitiesIndexRoute
  '/w/entity-templates': typeof WEntityTemplatesIndexRoute
  '/w/form': typeof WFormIndexRoute
  '/w/modules': typeof WModulesIndexRoute
  '/w/product-types': typeof WProductTypesIndexRoute
  '/w/roles': typeof WRolesIndexRoute
  '/w/signing-requests': typeof WSigningRequestsIndexRoute
  '/w/tenant-templates': typeof WTenantTemplatesIndexRoute
  '/w/users': typeof WUsersIndexRoute
  '/t/employees/profile/$employeeId': typeof TEmployeesProfileEmployeeIdRoute
  '/w/dashboard/profile/$tenantId': typeof WDashboardProfileTenantIdRoute
  '/w/employee-templates/view/$templateId': typeof WEmployeeTemplatesViewTemplateIdRoute
  '/w/employees/profile/$employeeId': typeof WEmployeesProfileEmployeeIdRoute
  '/w/entities/profile/$entityId': typeof WEntitiesProfileEntityIdRoute
  '/w/entity-templates/view/$templateId': typeof WEntityTemplatesViewTemplateIdRoute
  '/w/signing-requests/$requestId/edit': typeof WSigningRequestsRequestIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/component-showcase': typeof ComponentShowcaseRoute
  '/e': typeof ERouteWithChildren
  '/p': typeof PRouteWithChildren
  '/requested-details': typeof RequestedDetailsRoute
  '/t': typeof TRouteWithChildren
  '/w': typeof WRouteWithChildren
  '/e/employee-complete': typeof EEmployeeCompleteRoute
  '/e/employee-onboarding': typeof EEmployeeOnboardingRoute
  '/t/contracts': typeof TContractsRouteWithChildren
  '/t/departments': typeof TDepartmentsRouteWithChildren
  '/t/documents': typeof TDocumentsRouteWithChildren
  '/t/employees': typeof TEmployeesRouteWithChildren
  '/t/job-titles': typeof TJobTitlesRouteWithChildren
  '/t/roles': typeof TRolesRouteWithChildren
  '/t/signing-requests': typeof TSigningRequestsRouteWithChildren
  '/t/users': typeof TUsersRouteWithChildren
  '/w/contracts': typeof WContractsRouteWithChildren
  '/w/dashboard': typeof WDashboardRouteWithChildren
  '/w/document-templates': typeof WDocumentTemplatesRouteWithChildren
  '/w/document-types': typeof WDocumentTypesRouteWithChildren
  '/w/documents': typeof WDocumentsRouteWithChildren
  '/w/employee-templates': typeof WEmployeeTemplatesRouteWithChildren
  '/w/employees': typeof WEmployeesRouteWithChildren
  '/w/employment-types': typeof WEmploymentTypesRouteWithChildren
  '/w/entities': typeof WEntitiesRouteWithChildren
  '/w/entity-templates': typeof WEntityTemplatesRouteWithChildren
  '/w/form': typeof WFormRouteWithChildren
  '/w/modules': typeof WModulesRouteWithChildren
  '/w/product-types': typeof WProductTypesRouteWithChildren
  '/w/roles': typeof WRolesRouteWithChildren
  '/w/signing-requests': typeof WSigningRequestsRouteWithChildren
  '/w/tenant-templates': typeof WTenantTemplatesRouteWithChildren
  '/w/users': typeof WUsersRouteWithChildren
  '/e/': typeof EIndexRoute
  '/p/': typeof PIndexRoute
  '/t/': typeof TIndexRoute
  '/t/contracts/$snapshotId': typeof TContractsSnapshotIdRoute
  '/t/profile/$id': typeof TProfileIdRoute
  '/t/roles/add': typeof TRolesAddRoute
  '/t/signing-requests/$requestId': typeof TSigningRequestsRequestIdRoute
  '/w/contracts/$snapshotId': typeof WContractsSnapshotIdRoute
  '/w/document-templates/$templateId': typeof WDocumentTemplatesTemplateIdRoute
  '/w/employee-templates/add': typeof WEmployeeTemplatesAddRoute
  '/w/entity-templates/add': typeof WEntityTemplatesAddRoute
  '/w/form/add': typeof WFormAddRoute
  '/w/form/preview': typeof WFormPreviewRoute
  '/w/roles/add': typeof WRolesAddRoute
  '/w/signing-requests/$requestId': typeof WSigningRequestsRequestIdRoute
  '/w/signing-requests/new': typeof WSigningRequestsNewRoute
  '/t/contracts/': typeof TContractsIndexRoute
  '/t/departments/': typeof TDepartmentsIndexRoute
  '/t/document-templates/': typeof TDocumentTemplatesIndexRoute
  '/t/documents/': typeof TDocumentsIndexRoute
  '/t/employees/': typeof TEmployeesIndexRoute
  '/t/job-titles/': typeof TJobTitlesIndexRoute
  '/t/roles/': typeof TRolesIndexRoute
  '/t/signing-requests/': typeof TSigningRequestsIndexRoute
  '/t/users/': typeof TUsersIndexRoute
  '/w/contracts/': typeof WContractsIndexRoute
  '/w/dashboard/': typeof WDashboardIndexRoute
  '/w/document-templates/': typeof WDocumentTemplatesIndexRoute
  '/w/document-types/': typeof WDocumentTypesIndexRoute
  '/w/documents/': typeof WDocumentsIndexRoute
  '/w/employee-templates/': typeof WEmployeeTemplatesIndexRoute
  '/w/employees/': typeof WEmployeesIndexRoute
  '/w/employment-types/': typeof WEmploymentTypesIndexRoute
  '/w/entities/': typeof WEntitiesIndexRoute
  '/w/entity-templates/': typeof WEntityTemplatesIndexRoute
  '/w/form/': typeof WFormIndexRoute
  '/w/modules/': typeof WModulesIndexRoute
  '/w/product-types/': typeof WProductTypesIndexRoute
  '/w/roles/': typeof WRolesIndexRoute
  '/w/signing-requests/': typeof WSigningRequestsIndexRoute
  '/w/tenant-templates/': typeof WTenantTemplatesIndexRoute
  '/w/users/': typeof WUsersIndexRoute
  '/t/employees/profile/$employeeId': typeof TEmployeesProfileEmployeeIdRoute
  '/w/dashboard/profile/$tenantId': typeof WDashboardProfileTenantIdRoute
  '/w/employee-templates/view/$templateId': typeof WEmployeeTemplatesViewTemplateIdRoute
  '/w/employees/profile/$employeeId': typeof WEmployeesProfileEmployeeIdRoute
  '/w/entities/profile/$entityId': typeof WEntitiesProfileEntityIdRoute
  '/w/entity-templates/view/$templateId': typeof WEntityTemplatesViewTemplateIdRoute
  '/w/signing-requests/$requestId_/edit': typeof WSigningRequestsRequestIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/component-showcase'
    | '/e'
    | '/p'
    | '/requested-details'
    | '/t'
    | '/w'
    | '/e/employee-complete'
    | '/e/employee-onboarding'
    | '/t/contracts'
    | '/t/departments'
    | '/t/documents'
    | '/t/employees'
    | '/t/job-titles'
    | '/t/roles'
    | '/t/signing-requests'
    | '/t/users'
    | '/w/contracts'
    | '/w/dashboard'
    | '/w/document-templates'
    | '/w/document-types'
    | '/w/documents'
    | '/w/employee-templates'
    | '/w/employees'
    | '/w/employment-types'
    | '/w/entities'
    | '/w/entity-templates'
    | '/w/form'
    | '/w/modules'
    | '/w/product-types'
    | '/w/roles'
    | '/w/signing-requests'
    | '/w/tenant-templates'
    | '/w/users'
    | '/e/'
    | '/p/'
    | '/t/'
    | '/t/contracts/$snapshotId'
    | '/t/profile/$id'
    | '/t/roles/add'
    | '/t/signing-requests/$requestId'
    | '/w/contracts/$snapshotId'
    | '/w/document-templates/$templateId'
    | '/w/employee-templates/add'
    | '/w/entity-templates/add'
    | '/w/form/add'
    | '/w/form/preview'
    | '/w/roles/add'
    | '/w/signing-requests/$requestId'
    | '/w/signing-requests/new'
    | '/t/contracts/'
    | '/t/departments/'
    | '/t/document-templates/'
    | '/t/documents/'
    | '/t/employees/'
    | '/t/job-titles/'
    | '/t/roles/'
    | '/t/signing-requests/'
    | '/t/users/'
    | '/w/contracts/'
    | '/w/dashboard/'
    | '/w/document-templates/'
    | '/w/document-types/'
    | '/w/documents/'
    | '/w/employee-templates/'
    | '/w/employees/'
    | '/w/employment-types/'
    | '/w/entities/'
    | '/w/entity-templates/'
    | '/w/form/'
    | '/w/modules/'
    | '/w/product-types/'
    | '/w/roles/'
    | '/w/signing-requests/'
    | '/w/tenant-templates/'
    | '/w/users/'
    | '/t/employees/profile/$employeeId'
    | '/w/dashboard/profile/$tenantId'
    | '/w/employee-templates/view/$templateId'
    | '/w/employees/profile/$employeeId'
    | '/w/entities/profile/$entityId'
    | '/w/entity-templates/view/$templateId'
    | '/w/signing-requests/$requestId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/component-showcase'
    | '/requested-details'
    | '/w'
    | '/e/employee-complete'
    | '/e/employee-onboarding'
    | '/e'
    | '/p'
    | '/t'
    | '/t/contracts/$snapshotId'
    | '/t/profile/$id'
    | '/t/roles/add'
    | '/t/signing-requests/$requestId'
    | '/w/contracts/$snapshotId'
    | '/w/document-templates/$templateId'
    | '/w/employee-templates/add'
    | '/w/entity-templates/add'
    | '/w/form/add'
    | '/w/form/preview'
    | '/w/roles/add'
    | '/w/signing-requests/$requestId'
    | '/w/signing-requests/new'
    | '/t/contracts'
    | '/t/departments'
    | '/t/document-templates'
    | '/t/documents'
    | '/t/employees'
    | '/t/job-titles'
    | '/t/roles'
    | '/t/signing-requests'
    | '/t/users'
    | '/w/contracts'
    | '/w/dashboard'
    | '/w/document-templates'
    | '/w/document-types'
    | '/w/documents'
    | '/w/employee-templates'
    | '/w/employees'
    | '/w/employment-types'
    | '/w/entities'
    | '/w/entity-templates'
    | '/w/form'
    | '/w/modules'
    | '/w/product-types'
    | '/w/roles'
    | '/w/signing-requests'
    | '/w/tenant-templates'
    | '/w/users'
    | '/t/employees/profile/$employeeId'
    | '/w/dashboard/profile/$tenantId'
    | '/w/employee-templates/view/$templateId'
    | '/w/employees/profile/$employeeId'
    | '/w/entities/profile/$entityId'
    | '/w/entity-templates/view/$templateId'
    | '/w/signing-requests/$requestId/edit'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/component-showcase'
    | '/e'
    | '/p'
    | '/requested-details'
    | '/t'
    | '/w'
    | '/e/employee-complete'
    | '/e/employee-onboarding'
    | '/t/contracts'
    | '/t/departments'
    | '/t/documents'
    | '/t/employees'
    | '/t/job-titles'
    | '/t/roles'
    | '/t/signing-requests'
    | '/t/users'
    | '/w/contracts'
    | '/w/dashboard'
    | '/w/document-templates'
    | '/w/document-types'
    | '/w/documents'
    | '/w/employee-templates'
    | '/w/employees'
    | '/w/employment-types'
    | '/w/entities'
    | '/w/entity-templates'
    | '/w/form'
    | '/w/modules'
    | '/w/product-types'
    | '/w/roles'
    | '/w/signing-requests'
    | '/w/tenant-templates'
    | '/w/users'
    | '/e/'
    | '/p/'
    | '/t/'
    | '/t/contracts/$snapshotId'
    | '/t/profile/$id'
    | '/t/roles/add'
    | '/t/signing-requests/$requestId'
    | '/w/contracts/$snapshotId'
    | '/w/document-templates/$templateId'
    | '/w/employee-templates/add'
    | '/w/entity-templates/add'
    | '/w/form/add'
    | '/w/form/preview'
    | '/w/roles/add'
    | '/w/signing-requests/$requestId'
    | '/w/signing-requests/new'
    | '/t/contracts/'
    | '/t/departments/'
    | '/t/document-templates/'
    | '/t/documents/'
    | '/t/employees/'
    | '/t/job-titles/'
    | '/t/roles/'
    | '/t/signing-requests/'
    | '/t/users/'
    | '/w/contracts/'
    | '/w/dashboard/'
    | '/w/document-templates/'
    | '/w/document-types/'
    | '/w/documents/'
    | '/w/employee-templates/'
    | '/w/employees/'
    | '/w/employment-types/'
    | '/w/entities/'
    | '/w/entity-templates/'
    | '/w/form/'
    | '/w/modules/'
    | '/w/product-types/'
    | '/w/roles/'
    | '/w/signing-requests/'
    | '/w/tenant-templates/'
    | '/w/users/'
    | '/t/employees/profile/$employeeId'
    | '/w/dashboard/profile/$tenantId'
    | '/w/employee-templates/view/$templateId'
    | '/w/employees/profile/$employeeId'
    | '/w/entities/profile/$entityId'
    | '/w/entity-templates/view/$templateId'
    | '/w/signing-requests/$requestId_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  ComponentShowcaseRoute: typeof ComponentShowcaseRoute
  ERoute: typeof ERouteWithChildren
  PRoute: typeof PRouteWithChildren
  RequestedDetailsRoute: typeof RequestedDetailsRoute
  TRoute: typeof TRouteWithChildren
  WRoute: typeof WRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/w': {
      id: '/w'
      path: '/w'
      fullPath: '/w'
      preLoaderRoute: typeof WRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t': {
      id: '/t'
      path: '/t'
      fullPath: '/t'
      preLoaderRoute: typeof TRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/requested-details': {
      id: '/requested-details'
      path: '/requested-details'
      fullPath: '/requested-details'
      preLoaderRoute: typeof RequestedDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p': {
      id: '/p'
      path: '/p'
      fullPath: '/p'
      preLoaderRoute: typeof PRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e': {
      id: '/e'
      path: '/e'
      fullPath: '/e'
      preLoaderRoute: typeof ERouteImport
      parentRoute: typeof rootRouteImport
    }
    '/component-showcase': {
      id: '/component-showcase'
      path: '/component-showcase'
      fullPath: '/component-showcase'
      preLoaderRoute: typeof ComponentShowcaseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/': {
      id: '/t/'
      path: '/'
      fullPath: '/t/'
      preLoaderRoute: typeof TIndexRouteImport
      parentRoute: typeof TRoute
    }
    '/p/': {
      id: '/p/'
      path: '/'
      fullPath: '/p/'
      preLoaderRoute: typeof PIndexRouteImport
      parentRoute: typeof PRoute
    }
    '/e/': {
      id: '/e/'
      path: '/'
      fullPath: '/e/'
      preLoaderRoute: typeof EIndexRouteImport
      parentRoute: typeof ERoute
    }
    '/w/users': {
      id: '/w/users'
      path: '/users'
      fullPath: '/w/users'
      preLoaderRoute: typeof WUsersRouteImport
      parentRoute: typeof WRoute
    }
    '/w/tenant-templates': {
      id: '/w/tenant-templates'
      path: '/tenant-templates'
      fullPath: '/w/tenant-templates'
      preLoaderRoute: typeof WTenantTemplatesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/signing-requests': {
      id: '/w/signing-requests'
      path: '/signing-requests'
      fullPath: '/w/signing-requests'
      preLoaderRoute: typeof WSigningRequestsRouteImport
      parentRoute: typeof WRoute
    }
    '/w/roles': {
      id: '/w/roles'
      path: '/roles'
      fullPath: '/w/roles'
      preLoaderRoute: typeof WRolesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/product-types': {
      id: '/w/product-types'
      path: '/product-types'
      fullPath: '/w/product-types'
      preLoaderRoute: typeof WProductTypesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/modules': {
      id: '/w/modules'
      path: '/modules'
      fullPath: '/w/modules'
      preLoaderRoute: typeof WModulesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/form': {
      id: '/w/form'
      path: '/form'
      fullPath: '/w/form'
      preLoaderRoute: typeof WFormRouteImport
      parentRoute: typeof WRoute
    }
    '/w/entity-templates': {
      id: '/w/entity-templates'
      path: '/entity-templates'
      fullPath: '/w/entity-templates'
      preLoaderRoute: typeof WEntityTemplatesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/entities': {
      id: '/w/entities'
      path: '/entities'
      fullPath: '/w/entities'
      preLoaderRoute: typeof WEntitiesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/employment-types': {
      id: '/w/employment-types'
      path: '/employment-types'
      fullPath: '/w/employment-types'
      preLoaderRoute: typeof WEmploymentTypesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/employees': {
      id: '/w/employees'
      path: '/employees'
      fullPath: '/w/employees'
      preLoaderRoute: typeof WEmployeesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/employee-templates': {
      id: '/w/employee-templates'
      path: '/employee-templates'
      fullPath: '/w/employee-templates'
      preLoaderRoute: typeof WEmployeeTemplatesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/documents': {
      id: '/w/documents'
      path: '/documents'
      fullPath: '/w/documents'
      preLoaderRoute: typeof WDocumentsRouteImport
      parentRoute: typeof WRoute
    }
    '/w/document-types': {
      id: '/w/document-types'
      path: '/document-types'
      fullPath: '/w/document-types'
      preLoaderRoute: typeof WDocumentTypesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/document-templates': {
      id: '/w/document-templates'
      path: '/document-templates'
      fullPath: '/w/document-templates'
      preLoaderRoute: typeof WDocumentTemplatesRouteImport
      parentRoute: typeof WRoute
    }
    '/w/dashboard': {
      id: '/w/dashboard'
      path: '/dashboard'
      fullPath: '/w/dashboard'
      preLoaderRoute: typeof WDashboardRouteImport
      parentRoute: typeof WRoute
    }
    '/w/contracts': {
      id: '/w/contracts'
      path: '/contracts'
      fullPath: '/w/contracts'
      preLoaderRoute: typeof WContractsRouteImport
      parentRoute: typeof WRoute
    }
    '/t/users': {
      id: '/t/users'
      path: '/users'
      fullPath: '/t/users'
      preLoaderRoute: typeof TUsersRouteImport
      parentRoute: typeof TRoute
    }
    '/t/signing-requests': {
      id: '/t/signing-requests'
      path: '/signing-requests'
      fullPath: '/t/signing-requests'
      preLoaderRoute: typeof TSigningRequestsRouteImport
      parentRoute: typeof TRoute
    }
    '/t/roles': {
      id: '/t/roles'
      path: '/roles'
      fullPath: '/t/roles'
      preLoaderRoute: typeof TRolesRouteImport
      parentRoute: typeof TRoute
    }
    '/t/job-titles': {
      id: '/t/job-titles'
      path: '/job-titles'
      fullPath: '/t/job-titles'
      preLoaderRoute: typeof TJobTitlesRouteImport
      parentRoute: typeof TRoute
    }
    '/t/employees': {
      id: '/t/employees'
      path: '/employees'
      fullPath: '/t/employees'
      preLoaderRoute: typeof TEmployeesRouteImport
      parentRoute: typeof TRoute
    }
    '/t/documents': {
      id: '/t/documents'
      path: '/documents'
      fullPath: '/t/documents'
      preLoaderRoute: typeof TDocumentsRouteImport
      parentRoute: typeof TRoute
    }
    '/t/departments': {
      id: '/t/departments'
      path: '/departments'
      fullPath: '/t/departments'
      preLoaderRoute: typeof TDepartmentsRouteImport
      parentRoute: typeof TRoute
    }
    '/t/contracts': {
      id: '/t/contracts'
      path: '/contracts'
      fullPath: '/t/contracts'
      preLoaderRoute: typeof TContractsRouteImport
      parentRoute: typeof TRoute
    }
    '/e/employee-onboarding': {
      id: '/e/employee-onboarding'
      path: '/employee-onboarding'
      fullPath: '/e/employee-onboarding'
      preLoaderRoute: typeof EEmployeeOnboardingRouteImport
      parentRoute: typeof ERoute
    }
    '/e/employee-complete': {
      id: '/e/employee-complete'
      path: '/employee-complete'
      fullPath: '/e/employee-complete'
      preLoaderRoute: typeof EEmployeeCompleteRouteImport
      parentRoute: typeof ERoute
    }
    '/w/users/': {
      id: '/w/users/'
      path: '/'
      fullPath: '/w/users/'
      preLoaderRoute: typeof WUsersIndexRouteImport
      parentRoute: typeof WUsersRoute
    }
    '/w/tenant-templates/': {
      id: '/w/tenant-templates/'
      path: '/'
      fullPath: '/w/tenant-templates/'
      preLoaderRoute: typeof WTenantTemplatesIndexRouteImport
      parentRoute: typeof WTenantTemplatesRoute
    }
    '/w/signing-requests/': {
      id: '/w/signing-requests/'
      path: '/'
      fullPath: '/w/signing-requests/'
      preLoaderRoute: typeof WSigningRequestsIndexRouteImport
      parentRoute: typeof WSigningRequestsRoute
    }
    '/w/roles/': {
      id: '/w/roles/'
      path: '/'
      fullPath: '/w/roles/'
      preLoaderRoute: typeof WRolesIndexRouteImport
      parentRoute: typeof WRolesRoute
    }
    '/w/product-types/': {
      id: '/w/product-types/'
      path: '/'
      fullPath: '/w/product-types/'
      preLoaderRoute: typeof WProductTypesIndexRouteImport
      parentRoute: typeof WProductTypesRoute
    }
    '/w/modules/': {
      id: '/w/modules/'
      path: '/'
      fullPath: '/w/modules/'
      preLoaderRoute: typeof WModulesIndexRouteImport
      parentRoute: typeof WModulesRoute
    }
    '/w/form/': {
      id: '/w/form/'
      path: '/'
      fullPath: '/w/form/'
      preLoaderRoute: typeof WFormIndexRouteImport
      parentRoute: typeof WFormRoute
    }
    '/w/entity-templates/': {
      id: '/w/entity-templates/'
      path: '/'
      fullPath: '/w/entity-templates/'
      preLoaderRoute: typeof WEntityTemplatesIndexRouteImport
      parentRoute: typeof WEntityTemplatesRoute
    }
    '/w/entities/': {
      id: '/w/entities/'
      path: '/'
      fullPath: '/w/entities/'
      preLoaderRoute: typeof WEntitiesIndexRouteImport
      parentRoute: typeof WEntitiesRoute
    }
    '/w/employment-types/': {
      id: '/w/employment-types/'
      path: '/'
      fullPath: '/w/employment-types/'
      preLoaderRoute: typeof WEmploymentTypesIndexRouteImport
      parentRoute: typeof WEmploymentTypesRoute
    }
    '/w/employees/': {
      id: '/w/employees/'
      path: '/'
      fullPath: '/w/employees/'
      preLoaderRoute: typeof WEmployeesIndexRouteImport
      parentRoute: typeof WEmployeesRoute
    }
    '/w/employee-templates/': {
      id: '/w/employee-templates/'
      path: '/'
      fullPath: '/w/employee-templates/'
      preLoaderRoute: typeof WEmployeeTemplatesIndexRouteImport
      parentRoute: typeof WEmployeeTemplatesRoute
    }
    '/w/documents/': {
      id: '/w/documents/'
      path: '/'
      fullPath: '/w/documents/'
      preLoaderRoute: typeof WDocumentsIndexRouteImport
      parentRoute: typeof WDocumentsRoute
    }
    '/w/document-types/': {
      id: '/w/document-types/'
      path: '/'
      fullPath: '/w/document-types/'
      preLoaderRoute: typeof WDocumentTypesIndexRouteImport
      parentRoute: typeof WDocumentTypesRoute
    }
    '/w/document-templates/': {
      id: '/w/document-templates/'
      path: '/'
      fullPath: '/w/document-templates/'
      preLoaderRoute: typeof WDocumentTemplatesIndexRouteImport
      parentRoute: typeof WDocumentTemplatesRoute
    }
    '/w/dashboard/': {
      id: '/w/dashboard/'
      path: '/'
      fullPath: '/w/dashboard/'
      preLoaderRoute: typeof WDashboardIndexRouteImport
      parentRoute: typeof WDashboardRoute
    }
    '/w/contracts/': {
      id: '/w/contracts/'
      path: '/'
      fullPath: '/w/contracts/'
      preLoaderRoute: typeof WContractsIndexRouteImport
      parentRoute: typeof WContractsRoute
    }
    '/t/users/': {
      id: '/t/users/'
      path: '/'
      fullPath: '/t/users/'
      preLoaderRoute: typeof TUsersIndexRouteImport
      parentRoute: typeof TUsersRoute
    }
    '/t/signing-requests/': {
      id: '/t/signing-requests/'
      path: '/'
      fullPath: '/t/signing-requests/'
      preLoaderRoute: typeof TSigningRequestsIndexRouteImport
      parentRoute: typeof TSigningRequestsRoute
    }
    '/t/roles/': {
      id: '/t/roles/'
      path: '/'
      fullPath: '/t/roles/'
      preLoaderRoute: typeof TRolesIndexRouteImport
      parentRoute: typeof TRolesRoute
    }
    '/t/job-titles/': {
      id: '/t/job-titles/'
      path: '/'
      fullPath: '/t/job-titles/'
      preLoaderRoute: typeof TJobTitlesIndexRouteImport
      parentRoute: typeof TJobTitlesRoute
    }
    '/t/employees/': {
      id: '/t/employees/'
      path: '/'
      fullPath: '/t/employees/'
      preLoaderRoute: typeof TEmployeesIndexRouteImport
      parentRoute: typeof TEmployeesRoute
    }
    '/t/documents/': {
      id: '/t/documents/'
      path: '/'
      fullPath: '/t/documents/'
      preLoaderRoute: typeof TDocumentsIndexRouteImport
      parentRoute: typeof TDocumentsRoute
    }
    '/t/document-templates/': {
      id: '/t/document-templates/'
      path: '/document-templates'
      fullPath: '/t/document-templates/'
      preLoaderRoute: typeof TDocumentTemplatesIndexRouteImport
      parentRoute: typeof TRoute
    }
    '/t/departments/': {
      id: '/t/departments/'
      path: '/'
      fullPath: '/t/departments/'
      preLoaderRoute: typeof TDepartmentsIndexRouteImport
      parentRoute: typeof TDepartmentsRoute
    }
    '/t/contracts/': {
      id: '/t/contracts/'
      path: '/'
      fullPath: '/t/contracts/'
      preLoaderRoute: typeof TContractsIndexRouteImport
      parentRoute: typeof TContractsRoute
    }
    '/w/signing-requests/new': {
      id: '/w/signing-requests/new'
      path: '/new'
      fullPath: '/w/signing-requests/new'
      preLoaderRoute: typeof WSigningRequestsNewRouteImport
      parentRoute: typeof WSigningRequestsRoute
    }
    '/w/signing-requests/$requestId': {
      id: '/w/signing-requests/$requestId'
      path: '/$requestId'
      fullPath: '/w/signing-requests/$requestId'
      preLoaderRoute: typeof WSigningRequestsRequestIdRouteImport
      parentRoute: typeof WSigningRequestsRoute
    }
    '/w/roles/add': {
      id: '/w/roles/add'
      path: '/add'
      fullPath: '/w/roles/add'
      preLoaderRoute: typeof WRolesAddRouteImport
      parentRoute: typeof WRolesRoute
    }
    '/w/form/preview': {
      id: '/w/form/preview'
      path: '/preview'
      fullPath: '/w/form/preview'
      preLoaderRoute: typeof WFormPreviewRouteImport
      parentRoute: typeof WFormRoute
    }
    '/w/form/add': {
      id: '/w/form/add'
      path: '/add'
      fullPath: '/w/form/add'
      preLoaderRoute: typeof WFormAddRouteImport
      parentRoute: typeof WFormRoute
    }
    '/w/entity-templates/add': {
      id: '/w/entity-templates/add'
      path: '/add'
      fullPath: '/w/entity-templates/add'
      preLoaderRoute: typeof WEntityTemplatesAddRouteImport
      parentRoute: typeof WEntityTemplatesRoute
    }
    '/w/employee-templates/add': {
      id: '/w/employee-templates/add'
      path: '/add'
      fullPath: '/w/employee-templates/add'
      preLoaderRoute: typeof WEmployeeTemplatesAddRouteImport
      parentRoute: typeof WEmployeeTemplatesRoute
    }
    '/w/document-templates/$templateId': {
      id: '/w/document-templates/$templateId'
      path: '/$templateId'
      fullPath: '/w/document-templates/$templateId'
      preLoaderRoute: typeof WDocumentTemplatesTemplateIdRouteImport
      parentRoute: typeof WDocumentTemplatesRoute
    }
    '/w/contracts/$snapshotId': {
      id: '/w/contracts/$snapshotId'
      path: '/$snapshotId'
      fullPath: '/w/contracts/$snapshotId'
      preLoaderRoute: typeof WContractsSnapshotIdRouteImport
      parentRoute: typeof WContractsRoute
    }
    '/t/signing-requests/$requestId': {
      id: '/t/signing-requests/$requestId'
      path: '/$requestId'
      fullPath: '/t/signing-requests/$requestId'
      preLoaderRoute: typeof TSigningRequestsRequestIdRouteImport
      parentRoute: typeof TSigningRequestsRoute
    }
    '/t/roles/add': {
      id: '/t/roles/add'
      path: '/add'
      fullPath: '/t/roles/add'
      preLoaderRoute: typeof TRolesAddRouteImport
      parentRoute: typeof TRolesRoute
    }
    '/t/profile/$id': {
      id: '/t/profile/$id'
      path: '/profile/$id'
      fullPath: '/t/profile/$id'
      preLoaderRoute: typeof TProfileIdRouteImport
      parentRoute: typeof TRoute
    }
    '/t/contracts/$snapshotId': {
      id: '/t/contracts/$snapshotId'
      path: '/$snapshotId'
      fullPath: '/t/contracts/$snapshotId'
      preLoaderRoute: typeof TContractsSnapshotIdRouteImport
      parentRoute: typeof TContractsRoute
    }
    '/w/signing-requests/$requestId_/edit': {
      id: '/w/signing-requests/$requestId_/edit'
      path: '/$requestId/edit'
      fullPath: '/w/signing-requests/$requestId/edit'
      preLoaderRoute: typeof WSigningRequestsRequestIdEditRouteImport
      parentRoute: typeof WSigningRequestsRoute
    }
    '/w/entity-templates/view/$templateId': {
      id: '/w/entity-templates/view/$templateId'
      path: '/view/$templateId'
      fullPath: '/w/entity-templates/view/$templateId'
      preLoaderRoute: typeof WEntityTemplatesViewTemplateIdRouteImport
      parentRoute: typeof WEntityTemplatesRoute
    }
    '/w/entities/profile/$entityId': {
      id: '/w/entities/profile/$entityId'
      path: '/profile/$entityId'
      fullPath: '/w/entities/profile/$entityId'
      preLoaderRoute: typeof WEntitiesProfileEntityIdRouteImport
      parentRoute: typeof WEntitiesRoute
    }
    '/w/employees/profile/$employeeId': {
      id: '/w/employees/profile/$employeeId'
      path: '/profile/$employeeId'
      fullPath: '/w/employees/profile/$employeeId'
      preLoaderRoute: typeof WEmployeesProfileEmployeeIdRouteImport
      parentRoute: typeof WEmployeesRoute
    }
    '/w/employee-templates/view/$templateId': {
      id: '/w/employee-templates/view/$templateId'
      path: '/view/$templateId'
      fullPath: '/w/employee-templates/view/$templateId'
      preLoaderRoute: typeof WEmployeeTemplatesViewTemplateIdRouteImport
      parentRoute: typeof WEmployeeTemplatesRoute
    }
    '/w/dashboard/profile/$tenantId': {
      id: '/w/dashboard/profile/$tenantId'
      path: '/profile/$tenantId'
      fullPath: '/w/dashboard/profile/$tenantId'
      preLoaderRoute: typeof WDashboardProfileTenantIdRouteImport
      parentRoute: typeof WDashboardRoute
    }
    '/t/employees/profile/$employeeId': {
      id: '/t/employees/profile/$employeeId'
      path: '/profile/$employeeId'
      fullPath: '/t/employees/profile/$employeeId'
      preLoaderRoute: typeof TEmployeesProfileEmployeeIdRouteImport
      parentRoute: typeof TEmployeesRoute
    }
  }
}

interface ERouteChildren {
  EEmployeeCompleteRoute: typeof EEmployeeCompleteRoute
  EEmployeeOnboardingRoute: typeof EEmployeeOnboardingRoute
  EIndexRoute: typeof EIndexRoute
}

const ERouteChildren: ERouteChildren = {
  EEmployeeCompleteRoute: EEmployeeCompleteRoute,
  EEmployeeOnboardingRoute: EEmployeeOnboardingRoute,
  EIndexRoute: EIndexRoute,
}

const ERouteWithChildren = ERoute._addFileChildren(ERouteChildren)

interface PRouteChildren {
  PIndexRoute: typeof PIndexRoute
}

const PRouteChildren: PRouteChildren = {
  PIndexRoute: PIndexRoute,
}

const PRouteWithChildren = PRoute._addFileChildren(PRouteChildren)

interface TContractsRouteChildren {
  TContractsSnapshotIdRoute: typeof TContractsSnapshotIdRoute
  TContractsIndexRoute: typeof TContractsIndexRoute
}

const TContractsRouteChildren: TContractsRouteChildren = {
  TContractsSnapshotIdRoute: TContractsSnapshotIdRoute,
  TContractsIndexRoute: TContractsIndexRoute,
}

const TContractsRouteWithChildren = TContractsRoute._addFileChildren(
  TContractsRouteChildren,
)

interface TDepartmentsRouteChildren {
  TDepartmentsIndexRoute: typeof TDepartmentsIndexRoute
}

const TDepartmentsRouteChildren: TDepartmentsRouteChildren = {
  TDepartmentsIndexRoute: TDepartmentsIndexRoute,
}

const TDepartmentsRouteWithChildren = TDepartmentsRoute._addFileChildren(
  TDepartmentsRouteChildren,
)

interface TDocumentsRouteChildren {
  TDocumentsIndexRoute: typeof TDocumentsIndexRoute
}

const TDocumentsRouteChildren: TDocumentsRouteChildren = {
  TDocumentsIndexRoute: TDocumentsIndexRoute,
}

const TDocumentsRouteWithChildren = TDocumentsRoute._addFileChildren(
  TDocumentsRouteChildren,
)

interface TEmployeesRouteChildren {
  TEmployeesIndexRoute: typeof TEmployeesIndexRoute
  TEmployeesProfileEmployeeIdRoute: typeof TEmployeesProfileEmployeeIdRoute
}

const TEmployeesRouteChildren: TEmployeesRouteChildren = {
  TEmployeesIndexRoute: TEmployeesIndexRoute,
  TEmployeesProfileEmployeeIdRoute: TEmployeesProfileEmployeeIdRoute,
}

const TEmployeesRouteWithChildren = TEmployeesRoute._addFileChildren(
  TEmployeesRouteChildren,
)

interface TJobTitlesRouteChildren {
  TJobTitlesIndexRoute: typeof TJobTitlesIndexRoute
}

const TJobTitlesRouteChildren: TJobTitlesRouteChildren = {
  TJobTitlesIndexRoute: TJobTitlesIndexRoute,
}

const TJobTitlesRouteWithChildren = TJobTitlesRoute._addFileChildren(
  TJobTitlesRouteChildren,
)

interface TRolesRouteChildren {
  TRolesAddRoute: typeof TRolesAddRoute
  TRolesIndexRoute: typeof TRolesIndexRoute
}

const TRolesRouteChildren: TRolesRouteChildren = {
  TRolesAddRoute: TRolesAddRoute,
  TRolesIndexRoute: TRolesIndexRoute,
}

const TRolesRouteWithChildren =
  TRolesRoute._addFileChildren(TRolesRouteChildren)

interface TSigningRequestsRouteChildren {
  TSigningRequestsRequestIdRoute: typeof TSigningRequestsRequestIdRoute
  TSigningRequestsIndexRoute: typeof TSigningRequestsIndexRoute
}

const TSigningRequestsRouteChildren: TSigningRequestsRouteChildren = {
  TSigningRequestsRequestIdRoute: TSigningRequestsRequestIdRoute,
  TSigningRequestsIndexRoute: TSigningRequestsIndexRoute,
}

const TSigningRequestsRouteWithChildren =
  TSigningRequestsRoute._addFileChildren(TSigningRequestsRouteChildren)

interface TUsersRouteChildren {
  TUsersIndexRoute: typeof TUsersIndexRoute
}

const TUsersRouteChildren: TUsersRouteChildren = {
  TUsersIndexRoute: TUsersIndexRoute,
}

const TUsersRouteWithChildren =
  TUsersRoute._addFileChildren(TUsersRouteChildren)

interface TRouteChildren {
  TContractsRoute: typeof TContractsRouteWithChildren
  TDepartmentsRoute: typeof TDepartmentsRouteWithChildren
  TDocumentsRoute: typeof TDocumentsRouteWithChildren
  TEmployeesRoute: typeof TEmployeesRouteWithChildren
  TJobTitlesRoute: typeof TJobTitlesRouteWithChildren
  TRolesRoute: typeof TRolesRouteWithChildren
  TSigningRequestsRoute: typeof TSigningRequestsRouteWithChildren
  TUsersRoute: typeof TUsersRouteWithChildren
  TIndexRoute: typeof TIndexRoute
  TProfileIdRoute: typeof TProfileIdRoute
  TDocumentTemplatesIndexRoute: typeof TDocumentTemplatesIndexRoute
}

const TRouteChildren: TRouteChildren = {
  TContractsRoute: TContractsRouteWithChildren,
  TDepartmentsRoute: TDepartmentsRouteWithChildren,
  TDocumentsRoute: TDocumentsRouteWithChildren,
  TEmployeesRoute: TEmployeesRouteWithChildren,
  TJobTitlesRoute: TJobTitlesRouteWithChildren,
  TRolesRoute: TRolesRouteWithChildren,
  TSigningRequestsRoute: TSigningRequestsRouteWithChildren,
  TUsersRoute: TUsersRouteWithChildren,
  TIndexRoute: TIndexRoute,
  TProfileIdRoute: TProfileIdRoute,
  TDocumentTemplatesIndexRoute: TDocumentTemplatesIndexRoute,
}

const TRouteWithChildren = TRoute._addFileChildren(TRouteChildren)

interface WContractsRouteChildren {
  WContractsSnapshotIdRoute: typeof WContractsSnapshotIdRoute
  WContractsIndexRoute: typeof WContractsIndexRoute
}

const WContractsRouteChildren: WContractsRouteChildren = {
  WContractsSnapshotIdRoute: WContractsSnapshotIdRoute,
  WContractsIndexRoute: WContractsIndexRoute,
}

const WContractsRouteWithChildren = WContractsRoute._addFileChildren(
  WContractsRouteChildren,
)

interface WDashboardRouteChildren {
  WDashboardIndexRoute: typeof WDashboardIndexRoute
  WDashboardProfileTenantIdRoute: typeof WDashboardProfileTenantIdRoute
}

const WDashboardRouteChildren: WDashboardRouteChildren = {
  WDashboardIndexRoute: WDashboardIndexRoute,
  WDashboardProfileTenantIdRoute: WDashboardProfileTenantIdRoute,
}

const WDashboardRouteWithChildren = WDashboardRoute._addFileChildren(
  WDashboardRouteChildren,
)

interface WDocumentTemplatesRouteChildren {
  WDocumentTemplatesTemplateIdRoute: typeof WDocumentTemplatesTemplateIdRoute
  WDocumentTemplatesIndexRoute: typeof WDocumentTemplatesIndexRoute
}

const WDocumentTemplatesRouteChildren: WDocumentTemplatesRouteChildren = {
  WDocumentTemplatesTemplateIdRoute: WDocumentTemplatesTemplateIdRoute,
  WDocumentTemplatesIndexRoute: WDocumentTemplatesIndexRoute,
}

const WDocumentTemplatesRouteWithChildren =
  WDocumentTemplatesRoute._addFileChildren(WDocumentTemplatesRouteChildren)

interface WDocumentTypesRouteChildren {
  WDocumentTypesIndexRoute: typeof WDocumentTypesIndexRoute
}

const WDocumentTypesRouteChildren: WDocumentTypesRouteChildren = {
  WDocumentTypesIndexRoute: WDocumentTypesIndexRoute,
}

const WDocumentTypesRouteWithChildren = WDocumentTypesRoute._addFileChildren(
  WDocumentTypesRouteChildren,
)

interface WDocumentsRouteChildren {
  WDocumentsIndexRoute: typeof WDocumentsIndexRoute
}

const WDocumentsRouteChildren: WDocumentsRouteChildren = {
  WDocumentsIndexRoute: WDocumentsIndexRoute,
}

const WDocumentsRouteWithChildren = WDocumentsRoute._addFileChildren(
  WDocumentsRouteChildren,
)

interface WEmployeeTemplatesRouteChildren {
  WEmployeeTemplatesAddRoute: typeof WEmployeeTemplatesAddRoute
  WEmployeeTemplatesIndexRoute: typeof WEmployeeTemplatesIndexRoute
  WEmployeeTemplatesViewTemplateIdRoute: typeof WEmployeeTemplatesViewTemplateIdRoute
}

const WEmployeeTemplatesRouteChildren: WEmployeeTemplatesRouteChildren = {
  WEmployeeTemplatesAddRoute: WEmployeeTemplatesAddRoute,
  WEmployeeTemplatesIndexRoute: WEmployeeTemplatesIndexRoute,
  WEmployeeTemplatesViewTemplateIdRoute: WEmployeeTemplatesViewTemplateIdRoute,
}

const WEmployeeTemplatesRouteWithChildren =
  WEmployeeTemplatesRoute._addFileChildren(WEmployeeTemplatesRouteChildren)

interface WEmployeesRouteChildren {
  WEmployeesIndexRoute: typeof WEmployeesIndexRoute
  WEmployeesProfileEmployeeIdRoute: typeof WEmployeesProfileEmployeeIdRoute
}

const WEmployeesRouteChildren: WEmployeesRouteChildren = {
  WEmployeesIndexRoute: WEmployeesIndexRoute,
  WEmployeesProfileEmployeeIdRoute: WEmployeesProfileEmployeeIdRoute,
}

const WEmployeesRouteWithChildren = WEmployeesRoute._addFileChildren(
  WEmployeesRouteChildren,
)

interface WEmploymentTypesRouteChildren {
  WEmploymentTypesIndexRoute: typeof WEmploymentTypesIndexRoute
}

const WEmploymentTypesRouteChildren: WEmploymentTypesRouteChildren = {
  WEmploymentTypesIndexRoute: WEmploymentTypesIndexRoute,
}

const WEmploymentTypesRouteWithChildren =
  WEmploymentTypesRoute._addFileChildren(WEmploymentTypesRouteChildren)

interface WEntitiesRouteChildren {
  WEntitiesIndexRoute: typeof WEntitiesIndexRoute
  WEntitiesProfileEntityIdRoute: typeof WEntitiesProfileEntityIdRoute
}

const WEntitiesRouteChildren: WEntitiesRouteChildren = {
  WEntitiesIndexRoute: WEntitiesIndexRoute,
  WEntitiesProfileEntityIdRoute: WEntitiesProfileEntityIdRoute,
}

const WEntitiesRouteWithChildren = WEntitiesRoute._addFileChildren(
  WEntitiesRouteChildren,
)

interface WEntityTemplatesRouteChildren {
  WEntityTemplatesAddRoute: typeof WEntityTemplatesAddRoute
  WEntityTemplatesIndexRoute: typeof WEntityTemplatesIndexRoute
  WEntityTemplatesViewTemplateIdRoute: typeof WEntityTemplatesViewTemplateIdRoute
}

const WEntityTemplatesRouteChildren: WEntityTemplatesRouteChildren = {
  WEntityTemplatesAddRoute: WEntityTemplatesAddRoute,
  WEntityTemplatesIndexRoute: WEntityTemplatesIndexRoute,
  WEntityTemplatesViewTemplateIdRoute: WEntityTemplatesViewTemplateIdRoute,
}

const WEntityTemplatesRouteWithChildren =
  WEntityTemplatesRoute._addFileChildren(WEntityTemplatesRouteChildren)

interface WFormRouteChildren {
  WFormAddRoute: typeof WFormAddRoute
  WFormPreviewRoute: typeof WFormPreviewRoute
  WFormIndexRoute: typeof WFormIndexRoute
}

const WFormRouteChildren: WFormRouteChildren = {
  WFormAddRoute: WFormAddRoute,
  WFormPreviewRoute: WFormPreviewRoute,
  WFormIndexRoute: WFormIndexRoute,
}

const WFormRouteWithChildren = WFormRoute._addFileChildren(WFormRouteChildren)

interface WModulesRouteChildren {
  WModulesIndexRoute: typeof WModulesIndexRoute
}

const WModulesRouteChildren: WModulesRouteChildren = {
  WModulesIndexRoute: WModulesIndexRoute,
}

const WModulesRouteWithChildren = WModulesRoute._addFileChildren(
  WModulesRouteChildren,
)

interface WProductTypesRouteChildren {
  WProductTypesIndexRoute: typeof WProductTypesIndexRoute
}

const WProductTypesRouteChildren: WProductTypesRouteChildren = {
  WProductTypesIndexRoute: WProductTypesIndexRoute,
}

const WProductTypesRouteWithChildren = WProductTypesRoute._addFileChildren(
  WProductTypesRouteChildren,
)

interface WRolesRouteChildren {
  WRolesAddRoute: typeof WRolesAddRoute
  WRolesIndexRoute: typeof WRolesIndexRoute
}

const WRolesRouteChildren: WRolesRouteChildren = {
  WRolesAddRoute: WRolesAddRoute,
  WRolesIndexRoute: WRolesIndexRoute,
}

const WRolesRouteWithChildren =
  WRolesRoute._addFileChildren(WRolesRouteChildren)

interface WSigningRequestsRouteChildren {
  WSigningRequestsRequestIdRoute: typeof WSigningRequestsRequestIdRoute
  WSigningRequestsNewRoute: typeof WSigningRequestsNewRoute
  WSigningRequestsIndexRoute: typeof WSigningRequestsIndexRoute
  WSigningRequestsRequestIdEditRoute: typeof WSigningRequestsRequestIdEditRoute
}

const WSigningRequestsRouteChildren: WSigningRequestsRouteChildren = {
  WSigningRequestsRequestIdRoute: WSigningRequestsRequestIdRoute,
  WSigningRequestsNewRoute: WSigningRequestsNewRoute,
  WSigningRequestsIndexRoute: WSigningRequestsIndexRoute,
  WSigningRequestsRequestIdEditRoute: WSigningRequestsRequestIdEditRoute,
}

const WSigningRequestsRouteWithChildren =
  WSigningRequestsRoute._addFileChildren(WSigningRequestsRouteChildren)

interface WTenantTemplatesRouteChildren {
  WTenantTemplatesIndexRoute: typeof WTenantTemplatesIndexRoute
}

const WTenantTemplatesRouteChildren: WTenantTemplatesRouteChildren = {
  WTenantTemplatesIndexRoute: WTenantTemplatesIndexRoute,
}

const WTenantTemplatesRouteWithChildren =
  WTenantTemplatesRoute._addFileChildren(WTenantTemplatesRouteChildren)

interface WUsersRouteChildren {
  WUsersIndexRoute: typeof WUsersIndexRoute
}

const WUsersRouteChildren: WUsersRouteChildren = {
  WUsersIndexRoute: WUsersIndexRoute,
}

const WUsersRouteWithChildren =
  WUsersRoute._addFileChildren(WUsersRouteChildren)

interface WRouteChildren {
  WContractsRoute: typeof WContractsRouteWithChildren
  WDashboardRoute: typeof WDashboardRouteWithChildren
  WDocumentTemplatesRoute: typeof WDocumentTemplatesRouteWithChildren
  WDocumentTypesRoute: typeof WDocumentTypesRouteWithChildren
  WDocumentsRoute: typeof WDocumentsRouteWithChildren
  WEmployeeTemplatesRoute: typeof WEmployeeTemplatesRouteWithChildren
  WEmployeesRoute: typeof WEmployeesRouteWithChildren
  WEmploymentTypesRoute: typeof WEmploymentTypesRouteWithChildren
  WEntitiesRoute: typeof WEntitiesRouteWithChildren
  WEntityTemplatesRoute: typeof WEntityTemplatesRouteWithChildren
  WFormRoute: typeof WFormRouteWithChildren
  WModulesRoute: typeof WModulesRouteWithChildren
  WProductTypesRoute: typeof WProductTypesRouteWithChildren
  WRolesRoute: typeof WRolesRouteWithChildren
  WSigningRequestsRoute: typeof WSigningRequestsRouteWithChildren
  WTenantTemplatesRoute: typeof WTenantTemplatesRouteWithChildren
  WUsersRoute: typeof WUsersRouteWithChildren
}

const WRouteChildren: WRouteChildren = {
  WContractsRoute: WContractsRouteWithChildren,
  WDashboardRoute: WDashboardRouteWithChildren,
  WDocumentTemplatesRoute: WDocumentTemplatesRouteWithChildren,
  WDocumentTypesRoute: WDocumentTypesRouteWithChildren,
  WDocumentsRoute: WDocumentsRouteWithChildren,
  WEmployeeTemplatesRoute: WEmployeeTemplatesRouteWithChildren,
  WEmployeesRoute: WEmployeesRouteWithChildren,
  WEmploymentTypesRoute: WEmploymentTypesRouteWithChildren,
  WEntitiesRoute: WEntitiesRouteWithChildren,
  WEntityTemplatesRoute: WEntityTemplatesRouteWithChildren,
  WFormRoute: WFormRouteWithChildren,
  WModulesRoute: WModulesRouteWithChildren,
  WProductTypesRoute: WProductTypesRouteWithChildren,
  WRolesRoute: WRolesRouteWithChildren,
  WSigningRequestsRoute: WSigningRequestsRouteWithChildren,
  WTenantTemplatesRoute: WTenantTemplatesRouteWithChildren,
  WUsersRoute: WUsersRouteWithChildren,
}

const WRouteWithChildren = WRoute._addFileChildren(WRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  ComponentShowcaseRoute: ComponentShowcaseRoute,
  ERoute: ERouteWithChildren,
  PRoute: PRouteWithChildren,
  RequestedDetailsRoute: RequestedDetailsRoute,
  TRoute: TRouteWithChildren,
  WRoute: WRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
